module.exports = __webpack_public_path__ + "43d11c1803f4e13efe6a3064efd446a3.svg";